import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'change_password_modal.title',
  },
  passwordMsg: {
    id: 'signup_auth_params_security.password_msg',
  },
  confirmPasswordError: {
    id: 'signup_create_password.confirm_password.error',
  },
  requiredField: {
    id: 'required.field',
  },
  currentPasswordTitle: {
    id: 'change_password_modal.current_password_title',
  },
  currentPassword: {
    id: 'change_password_modal.current_password',
  },
  newPasswordTitle: {
    id: 'change_password_modal.new_password_title',
  },
  newPassword: {
    id: 'change_password_modal.new_password',
  },
  confirmPassword: {
    id: 'change_password_modal.confirm_password',
  },
  cancel: {
    id: 'addContract.cancel',
  },
  valid: {
    id: 'recovery_forgot_password.insert_new_password.title_button_valid',
  },
});
